import React from 'react';
import css from './LandingPage.module.css';
import IconCard from '../../components/SavedCardDetails/IconCard/IconCard';
import logo from '../../assets/logo.png';

export const LandingPageComponent = () => {
  return (
    <div className={css.root}>
      <div className={css.container}>
        <div className={css.logo}>
          <img src={logo} alt="She Who Wins" className={css.logoImage} />
        </div>

        <h1 className={css.title}>She Who Wins</h1>

        <p className={css.subtitle}>Real support. In real time. From women who get it.</p>

        <div className={css.buttonGroup}>
          <a href="https://shewinsapp.com" className={css.primaryButton}>
            Get In Touch
          </a>

          <a href="https://shewinsapp.com" className={css.secondaryButton}>
            Learn More
          </a>
        </div>

        <div className={css.appStoreButtons}>
          <a
            href="https://apps.apple.com/app/she-who-wins/id6748598745"
            target="_blank"
            rel="noopener noreferrer"
            className={css.appStoreLink}
          >
            <IconCard brand="appstore" />
          </a>

          <a
            href="https://play.google.com/store/apps/details?id=com.shewhowins"
            target="_blank"
            rel="noopener noreferrer"
            className={css.appStoreLink}
          >
            <IconCard brand="playstore" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default LandingPageComponent;
